<template>
  <div>

    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">

            <a target="_blank" :href="'/api/debts/xlsx'" class="btn btn-link" title="Ekspordi Excelisse">
              <i class="mdi mdi-download mr-1"></i>
              Ekspordi Excelisse
            </a>

            <permission name="DebtsRefresh">
              <button type="button" class="btn btn-primary" @click="refreshDebts" :disabled="working">
                <i class="mdi" :class="{'mdi-refresh': !working, 'mdi-loading mdi-spin': working}"></i> Uuenda
              </button>
            </permission>
          </div>
          <h4 class="page-title">Võlglased</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-xl-12">
        <div class="card">
          <div class="card-body">
            <table id="debts-list" class="table table-centered table-sm table-hover table-expandable table-sticky">
              <thead>
              <tr>
                <th>Klient</th>
                <th>Arve</th>
                <th>Kuupäev</th>
                <th>Tähtaeg</th>
                <th>Päevi</th>
                <th class="text-right">Võlgnevus</th>
                <th class="text-right">Krediidilimiit</th>
                <th class="text-right">Kasutamata</th>
              </tr>
              </thead>
              <template v-for="(client) in debts">
                <tbody>
                  <tr class="headline-row">
                    <th colspan="5">
                      <a @click="clientDetails(client.clientId, client.clientName)">{{client.clientName}}</a>
                    </th>
                    <th class="text-right">{{client.debt | amountWithCurrency}}</th>
                    <th class="text-right">{{client.limit | amountWithCurrency}}</th>
                    <th class="text-right">{{client.saldo | amountWithCurrency}}</th>
                  </tr>
                  <template v-for="invoice in client.invoices">
                    <tr>
                      <td></td>
                      <td>
                        <router-link :to="`/invoices/${invoice.id}`">{{invoice.number}}</router-link>
                      </td>
                      <td >{{invoice.date | formatDate}}</td>
                      <td>{{invoice.dueDate | formatDate}} <small class="muted">{{invoice.overDueDays}}</small></td>
                      <td>{{invoice.overdueDays}}</td>
                      <td class="text-right">{{invoice.amount | amountWithCurrency}}</td>
                      <td class="w-50" colspan="2">{{invoice.notes}}</td>
                    </tr>
                  </template>
                </tbody>
              </template>
              <tbody>
                <tr class="headline-row">
                  <th>Kokku</th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th class="text-right">{{totalDebts | amountWithCurrency}}</th>
                  <th></th>
                  <th></th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import gateway from '@/services/gateway'

  export default {
    data() {
      return {
        debts: [],
        working: false
      }
    },
    methods: {
      clientDetails(id, name) {
        this.$store.commit('client', {id: id, name: name})
        this.$router.push('/client')
      },
      refreshDebts() {
        this.working = true
        gateway.post('/debts/refresh').then(() => {
          this.working = false
          this.loadData()
        }).catch(() => this.working = false)
      },
      loadData() {
        gateway.get('/debts').then(r => this.debts = r.data)
      }
    },
    created() {
      this.loadData()
    },
    computed: {
      totalDebts() {
        return this.debts.map(c => c.debt).reduce((a, b) => a + b, 0)
      }
    }
  }
</script>
